import { generateId } from '@vedalib/editor/lib/utils/id'
import { useCallback } from 'react'

import Button from 'components/uiKit/Button'
import { KitSize } from 'components/uiKit/KitTypes'
import { t } from 'services/Translation'

import type { ArrayValue, IRenderButtonAddItem } from './types'

const ButtonAddItem = <V extends ArrayValue>({
  name,
  defaultItem,
  max,
  array,
  onChange,
}: IRenderButtonAddItem<V>) => {
  const handleAdd = useCallback(() => {
    const item = { ...defaultItem, value: generateId() } as V
    onChange?.([...array, item], { command: 'add', item })
  }, [onChange, defaultItem, array])

  return (
    <Button
      disabled={Boolean(max && array.length >= max)}
      name={`${name}.addItem`}
      onClick={handleAdd}
      size={KitSize.L}
      fluid
    >
      {t('uiKit.button.add')}
    </Button>
  )
}

export default ButtonAddItem
